<template>
  <div>
    <RewardAccountingClientsView v-if="$getConstRole('ROLE_ACCOUNTING') == role"></RewardAccountingClientsView>
    <RewardAdminClientsView v-if="$getConstRole('ROLE_ADMIN') == role"></RewardAdminClientsView>
    <RewardAgentClientsView v-if="$getConstRole('ROLE_AGENT') == role"></RewardAgentClientsView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RewardAccountingClientsView from '@/views/accountant/rewards/Clients.vue'
import RewardAdminClientsView from '@/views/admin/rewards/Clients.vue'
import RewardAgentClientsView from '@/views/agent/rewards/Clients.vue'

export default {
  name: 'RewardClients',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    RewardAccountingClientsView,
    RewardAdminClientsView,
    RewardAgentClientsView
  },
};
</script>
